var _excluded = ["children", "promoTextIndexes", "numberOfColumns"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
import HorizontalScrollItemsOrg from "../HorizontalScrollItemsOrg";
var gutterSpace = 0.5;
var additionalSafeSpace = 5; /* Additional space for box-shadow of items so that they're not hidden through overflow: hidden */

var StyledPackageBoxesOrg = styled.div.withConfig({
  componentId: "sc-vhfmjs-0"
})(function (_ref) {
  var $boxWithPromoTextIndex = _ref.$boxWithPromoTextIndex;
  if ($boxWithPromoTextIndex.length === 0) {
    return null;
  }
  return css(["width:100%;"]);
});
var Container = styled.div.withConfig({
  componentId: "sc-vhfmjs-1"
})(function (_ref2) {
  var $numberOfColumns = _ref2.$numberOfColumns;
  return css(["display:grid;gap:0 ", ";grid-template-columns:repeat(", ",1fr);", "{display:none;}"], space(gutterSpace), $numberOfColumns, breakpoint("small", "huge"));
});
var StyledHorizontalScrollItemsOrg = styled(HorizontalScrollItemsOrg).withConfig({
  componentId: "sc-vhfmjs-2"
})(function (_ref3) {
  var $numberOfColumns = _ref3.$numberOfColumns;
  return css(["margin-bottom:", ";padding-bottom:", ";display:grid;gap:0 ", ";grid-template-columns:repeat(", ",1fr);grid-auto-flow:column;grid-auto-columns:1fr;overflow:auto;", "{display:none;}"], space(-1 * additionalSafeSpace), space(additionalSafeSpace), space(gutterSpace), $numberOfColumns, breakpoint("huge"));
});
function PackageBoxesSlimOrg(_ref4) {
  var children = _ref4.children,
    promoTextIndexes = _ref4.promoTextIndexes,
    numberOfColumns = _ref4.numberOfColumns,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/React.createElement(StyledPackageBoxesOrg, _extends({
    $boxWithPromoTextIndex: promoTextIndexes || []
  }, restProps), /*#__PURE__*/React.createElement(Container, {
    $numberOfColumns: numberOfColumns
  }, children), /*#__PURE__*/React.createElement(StyledHorizontalScrollItemsOrg, {
    $numberOfColumns: numberOfColumns,
    gutterSpace: gutterSpace,
    itemWidthSpace: {
      small: 35,
      medium: 60,
      large: 60
    }
  }, children));
}
export default PackageBoxesSlimOrg;